import { QueryFilterBuilder } from '../helpers/types/query-filter-builder.type';
import { PlainObject } from 'odata-query';
import { ColumnFilterDefinition } from './column-filter-definition';
import { ODataFilter } from '@shared/modules/grid/abstractions';

export class ColumnFilterState<T> implements ODataFilter {
  private value?: T;
  private query!: PlainObject;
  private columnFilter!: ColumnFilterDefinition;

  assignWithoutTrigger: boolean = false;
  isExternal: boolean = false;
  checkSessionFn?: () => void;

  constructor() {
    this.reset();
  }

  get columnName(): string {
    return this.columnFilter?.columnKey ?? '';
  }

  get columnQueryBuilder(): QueryFilterBuilder | undefined {
    return this.columnFilter?.queryBuilder ?? undefined;
  }

  get path(): string {
    return this.columnFilter?.key ?? '';
  }

  get label(): string {
    return this.columnFilter?.label ?? '';
  }

  get isLoaded(): boolean {
    return this.columnFilter.isLoaded;
  }

  build(columnFilter: ColumnFilterDefinition, isExternal?: boolean): void {
    this.columnFilter = columnFilter;
    this.query = {};
    this.query[this.path] = {};
    this.isExternal = !!isExternal;
  }

  reset(): void {
    this.value = undefined;
    this.query = {};
    this.query[this.path] = {};
  }

  hasValue(): boolean {
    return (
      (this.value && Array.isArray(this.value) && this.value.length > 0) ||
      (!!this.value && !Array.isArray(this.value))
    );
  }

  getValue<T>(): T {
    return this.value as T;
  }

  getQuery(): PlainObject {
    return this.query;
  }

  updateValue(value: T): void {
    this.value = value;
  }

  updateQuery(query: PlainObject): PlainObject {
    this.query[this.path] = query;
    return this.query;
  }
}
